import { CalendarDays, MapPin, MoveRight, Phone } from "lucide-react";
import { images } from "../assets/assets";
import Navbar from "../Components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import { useState, useEffect } from "react";
import { getAllNews } from "../api";

const News = () => {
  const [NewsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAllNews();
        setNewsData(response?.data || []);
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Failed to load news. Please try again later.");
        setNewsData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // Skeleton Loader Component
  const SkeletonLoader = () => (
    <div className="w-full sm:w-[90%] md:w-[85%] grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6 mx-auto my-6 sm:my-8 px-4 sm:px-0">
      {[1, 2, 3, 4].map((idx) => (
        <div
          key={idx}
          className="bg-[#C9DCDE1A] rounded-[15px] p-4 sm:p-6 border border-transparent space-y-3"
        >
          {/* Category Badge Skeleton */}
          <div className="h-7 w-24 bg-gray-200 rounded-full animate-pulse"></div>
          
          {/* Headline Skeleton */}
          <div className="space-y-2">
            <div className="h-5 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-5 w-3/4 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Description Skeleton */}
          <div className="space-y-2">
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-5/6 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Date & Location Skeleton */}
          <div className="space-y-2">
            <div className="h-4 w-1/2 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-1/2 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Highlights Skeleton */}
          <div className="space-y-2 pt-2">
            <div className="h-4 w-1/3 bg-gray-200 rounded animate-pulse"></div>
            <div className="grid grid-cols-2 gap-2">
              {[1, 2, 3, 4].map((h) => (
                <div key={h} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
  // const NewsData = [
  //   {
  //     category: "Health Camp",
  //     headline: "Free Health Camp on April 5, 2026",
  //     desc: "We are organizing a free health screening camp for the community. Services include blood pressure check, blood sugar test, BMI assessment, and general health consultation.",
  //     date: "March 25, 2026",
  //     location: "Dev Rishi Hospital Main Campus",
  //     highlights: [
  //       "Free health screening for all",
  //       "Expert doctor consultations",
  //       "Free basic medications",
  //       "Health awareness sessions",
  //     ],
  //   },
  //   {
  //     category: "Announcement",
  //     headline: "New Advanced ICU Facility Inaugurated",
  //     desc: "We are organizing a free health screening camp for the community. Services include blood pressure check, blood sugar test, BMI assessment, and general health consultation.",
  //     date: "March 20, 2026",
  //     location: "Dev Rishi Hospital",
  //     highlights: [
  //       "20 modern ICU beds",
  //       "Advanced monitoring systems",
  //       "Experienced critical care team",
  //       "24/7 specialist availability",
  //     ],
  //   },
  //   {
  //     category: "Event",
  //     headline: "World Health Day Celebration",
  //     desc: "Join us in celebrating World Health Day with special awareness programs, free consultations, and health education sessions for the community.",
  //     date: "March 15, 2026",
  //     location: "Dev Rishi Hospital",
  //     highlights: [
  //       "Free health consultations",
  //       "Nutrition counseling",
  //       "Fitness demonstrations",
  //       "Health education materials",
  //     ],
  //   },
  //   {
  //     category: "Vaccination",
  //     headline: "COVID-19 Vaccination Drive Continues",
  //     desc: "Our ongoing COVID-19 vaccination drive continues with booster doses available for all eligible citizens. Walk-in facility available.",
  //     date: "March 10, 2026",
  //     location: "All Branches",
  //     highlights: [
  //       "Walk-in facility available",
  //       "All vaccine types available",
  //       "Booster doses provided",
  //       "Free of cost for eligible",
  //     ],
  //   },
  // ];
  return (
    <div className="font-lato">
      <Navbar />
      <div className="bg-[#F7F7F7B2] hover:bg-[#EFEFEF] active:bg-[#E8E8E8] py-4 sm:py-6 md:py-8 flex justify-center px-4 transition-colors duration-200">
        <div className="flex flex-col sm:flex-row justify-center sm:justify-start gap-2 sm:gap-4 items-center max-w-[1100px]">
          <img
            src={images.Logo}
            alt="logo"
            className="w-[50px] h-[50px] sm:w-[80px] sm:h-[80px] md:w-[95px] md:h-[95px] flex-shrink-0 hover:scale-105 transition-transform duration-300"
          />
          <div className="max-w-[500px]">
            <p className="font-bold text-[16px] sm:text-[20px] md:text-[24px] text-center sm:text-left">
              Hospital News
            </p>
            <p className="font-openSans text-[12px] sm:text-[14px] md:text-[16px] leading-[1.2] text-center sm:text-left text-gray-700">
              Stay updated with the latest news, medical camps, events, and
              announcements from Dev Rishi Hospital.
            </p>
          </div>
        </div>
      </div>

      {/* Loading State */}
      {loading && <SkeletonLoader />}

      {/* Error State */}
      {error && !loading && (
        <div className="flex flex-col items-center justify-center py-16 px-4">
          <div className="text-center max-w-[500px]">
            <p className="text-3xl mb-4">⚠️</p>
            <p className="text-lg font-semibold text-red-600 mb-2">Error Loading News</p>
            <p className="text-gray-600 mb-6">{error}</p>
            <div className="flex gap-4 justify-center flex-wrap">
              <button
                onClick={() => window.location.reload()}
                className="bg-[#1975FF] text-white px-6 py-2 rounded-[8px] hover:bg-[#1560d4] transition-colors duration-200"
              >
                Try Again
              </button>
              <Link
                to="/"
                className="border border-[#1975FF] text-[#1975FF] px-6 py-2 rounded-[8px] hover:bg-[#1975FF] hover:text-white transition-colors duration-200"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Empty State */}
      {!loading && !error && NewsData.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16 px-4">
          <div className="text-center">
            <p className="text-lg font-semibold text-gray-600 mb-2">📰 No News Available</p>
            <p className="text-gray-500">Check back soon for the latest updates and announcements.</p>
          </div>
        </div>
      )}

      {/* News Grid */}
      {!loading && !error && NewsData.length > 0 && (
        <div className="w-full sm:w-[90%] md:w-[85%] grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6 mx-auto my-6 sm:my-8 px-4 sm:px-0">
          {NewsData.map((news, idx) => (
          <div
            key={idx}
            className="bg-[#C9DCDE1A] hover:bg-[#C9DCDE35] active:bg-[#C9DCDE4D] rounded-[15px] p-4 sm:p-6 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] cursor-pointer border border-transparent hover:border-[#D4AF37]"
          >
            {/* category */}
            <p className="w-fit text-white bg-[#D4AF37] hover:bg-[#C4A027] active:bg-[#B49017] py-1.5 px-3 sm:px-4 text-xs sm:text-[13px] rounded-[18px] transition-colors duration-200 cursor-pointer">
              {news.category}
            </p>
            <h3 className="text-base sm:text-lg md:text-[18px] font-semibold text-black my-2 sm:my-3 leading-snug">
              {news.headline}
            </h3>
            <p className="text-sm sm:text-[15px] font-openSans text-gray-700 leading-relaxed">
              {news.desc}
            </p>
            <div className="flex items-center gap-1 sm:gap-2 my-2 sm:my-3 hover:text-gray-900 transition-colors duration-200">
              <CalendarDays
                color="#4E4C4C"
                className="w-4 h-4 -mt-0.5 flex-shrink-0"
              />
              <p className="text-[#4E4C4C] text-xs sm:text-[14px] font-poppins">
                {news.date}
              </p>
            </div>
            <div className="flex items-center gap-1 sm:gap-2 my-1 sm:my-2 hover:text-gray-900 transition-colors duration-200">
              <MapPin
                color="#4E4C4C"
                className="w-4 h-4 -mt-0.5 flex-shrink-0"
              />
              <p className="text-[#4E4C4C] text-xs sm:text-[14px] font-poppins">
                {news.location}
              </p>
            </div>
            <h3 className="text-sm sm:text-base md:text-[16px] font-semibold text-black my-2 sm:my-3 ">
              Key Highlights:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-x-5 sm:gap-y-3">
              {Array.isArray(news?.highlights) && news.highlights.map((highlight, idx) => (
                <div
                  key={idx}
                  className="flex gap-2 items-start sm:items-center p-2 rounded-lg hover:bg-[#D4AF3720] active:bg-[#D4AF3740] transition-colors duration-200 group cursor-pointer"
                >
                  <p className="p-[3px] bg-black group-hover:bg-[#D4AF37] rounded-full flex-shrink-0 transition-colors duration-200"></p>
                  <p className="font-openSans text-xs sm:text-[14px] text-black group-hover:text-gray-900">
                    {highlight}
                  </p>
                </div>
              ))}
            </div>
          </div>
            ))}
        </div>
      )}
       {/*  Book Consultation  */}
      <div className="py-8 sm:py-10 md:py-12 bg-[#F7F7F7B2] px-4 mt-10 mb-14">
        <h1 className="max-w-[550px] text-center text-[20px] sm:text-[26px] md:text-[32px] font-semibold mx-auto leading-[1.2]">
          Book Your Consultation
        </h1>
        <p className="max-w-[600px] font-openSans text-[13px] sm:text-[16px] md:text-[18px] mx-auto text-center mt-3 px-2">
          Your heart deserves the best care. Don’t ignore early signs—consult our specialists today for accurate diagnosis, personalized treatment, and complete support throughout your journey to better health.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8">
          <Link
            to="/appointment"
            className="bg-[#1975FF] rounded-[8px] sm:rounded-[10px] py-2 sm:py-1 pr-1 pl-3 sm:pl-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-white hover:bg-[#1560d4] hover:shadow-lg hover:-translate-y-0.5 active:bg-[#1050b8] active:scale-95 active:shadow-md transition-all duration-200 shadow-md group"
          >
            Book Appointment{" "}
            <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
              <MoveRight
                color="#000"
                className="rotate-[-38deg] w-3.5 h-3.5 sm:w-4 sm:h-4"
              />
            </span>
          </Link>
          <a
            href="tel:+917300906444"
            className="border border-black rounded-[8px] sm:rounded-[10px] py-1.5 sm:py-0.5 px-3 sm:px-4 flex items-center justify-center gap-2 text-[13px] sm:text-[14px] font-semibold text-black bg-white hover:bg-black hover:text-white hover:shadow-lg hover:-translate-y-0.5 active:scale-95 active:shadow-md transition-all duration-200"
          >
            <span className="p-2 bg-[#F59E0B] rounded-full transition-all duration-300 group-hover:bg-white">
              <Phone color="#ffffff" className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            </span>
            Call Now
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default News;
